import React from 'react';
import classNames from 'classnames';
import { getSponsorConfig } from 'helpers/sponsorConfig';

interface SponsorLogoProps {
  className?: string;
  type?: 'horizontal' | 'stacked';
}

const SponsorLogo = ({ className }: SponsorLogoProps) => {
  const sponsorConfig = getSponsorConfig();

  if (!sponsorConfig) {
    return null;
  }

  const { logo, url, alt, track } = sponsorConfig;

  return (
    <div className={classNames('landing-header-sponsor-logo', className)}>
      <div className="sponsor-logo-label">Presented by</div>
      <a href={url} rel="noreferrer noopener" target="_blank" onClick={track}>
        <img src={logo} alt={alt} />
      </a>
    </div>
  );
};

export default SponsorLogo;
